import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useThemeContext } from "@app/contexts/theme-context"
import { useState } from "react"

const MobileHospitalityVenue = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isTablet } = useThemeContext();

  return (
    <div className="flex items-center">
      <div
        className=" h-full w-full bg-cover bg-top bg-no-repeat"
        style={{
          backgroundImage: isTablet ? "url('/images/industries/hospitality.png')" :
            "url('/images/industries/mobile-hospitality.png')",
        }}
      >
        <div className="flex flex-col bg-opacity-80 bg-black px-8 py-6  md:space-y-3 space-y-1 xs:space-y-2">
          <TextGradient>
            <p className="h2">03</p>
          </TextGradient>
          <p className="mobile-h3 2xs:mobile-h2  text-light pb-4">Hospitality & Venue</p>
          <GradientContainer overrideClassName="w-[30%] h-2" />
          <div className="text-light text-sm 2xs:text-base pt-4 space-y-2 xs:space-y-5">
            <p>
              Our unique service model and technology platform are ideal for
              operators of restaurants, hotels, casinos, entertainment venues,
              gaming establishments, golf
              & country clubs, resorts, and more!
            </p>
            <p className="hidden xs:block">
              We combine all aspects of procurement, technology, and support to
              provide your business with the best pricing, guaranteed. Optimize your operations,
              administration, and purchasing through our Sole Source User Interface.
            </p>
            {isExpanded && (
              <div className="space-y-5">
                <p className="xs:hidden">
                  We combine all aspects of procurement, technology, and support to
                  provide your business with the best pricing, guaranteed. Optimize your operations,
                  administration, and purchasing through our Sole Source User Interface.
                </p>
                <p>
                  Optimize your operations, administration, and purchasing through our Sole Source User Interface.
                </p>
                <p>
                  Immediate savings are available through the SimpleWaste
                  technology platform.
                </p>
              </div>
            )}
          </div>
          <div className="pt-2">
            <Button onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? 'Read less' : 'Read more'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileHospitalityVenue;